<template>
    <div class="kgr-inputGroup">
        <kgr-form-row
            :label="label"
            :error="error"
            field-name="membershipNumber"
        >
            <div class="input-wrapper">
                <input
                    v-if="isEditable"
                    type="text"
                    :value="value.toString()"
                    class="kgr-input"
                    disabled
                    :placeholder="$t('-- wird generiert --')"
                />
                <div v-else>
                    {{ value.toString() ? value.toString() : $t('-- wird generiert --') }}
                </div>
                <kgr-icon
                    v-if="isEditable"
                    icon-class="edit"
                    class="icon"
                    :title="$t('Mitgliedsnummer manuell vergeben')"
                    @click="onEdit()"
                />
            </div>
        </kgr-form-row>

        <kgr-membership-number-dialog
            :id="dialogId"
            :value="value"
            :show="showLightbox"
            :club-id="clubId"
            :member-id="memberId"
            @close="close()"
            @input="onSave($event)"
        />
    </div>
</template>

<script>
import Error from '../../../js/model/Error';
import FormRow from '../../common/form/FormRow';
import Icon from '../../common/icon/Icon.vue';
import MembershipNumber from '../../../js/dto/MembershipNumber';
import MembershipNumberDialog from './MembershipNumberDialog';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-membership-number-dialog': MembershipNumberDialog,
        'kgr-icon': Icon,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        value: {
            type: MembershipNumber,
            required: true,
        },
        label: {
            type: String,
            required: false,
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    emits: ['input', 'enter'],
    data() {
        return {
            showLightbox: false,
            dialogId: null,
        };
    },
    mounted() {
        this.dialogId = `${this._uid}-dialog`;
    },
    methods: {
        onEdit() {
            this.showLightbox = true;
            document.body.appendChild(document.getElementById(this.dialogId)); // fix positioning problems
        },
        onKeyUpEnter() {
            this.$emit('enter');
        },
        close() {
            this.showLightbox = false;
        },
        onSave(updated) {
            this.$emit('input', updated);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .input-wrapper svg {
    position: absolute;
}
.icon {
    right: 5px;
    top: 5px;
    cursor: pointer;
    color: var(--kgr-text-color);
}
</style>
